import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import SubjectsNotifications from '@UI/Pages/Subjects/SubjectsNotifications';
import useSubjectAddressParams from '@UI/Pages/Beneficiaries/Hooks/Params/useSubjectAddressParams';
import SubjectBreadcrumb from '@UI/Pages/Beneficiaries/Shared/SubjectBreadcrumb';
import SubjectReadingColumn from '@UI/Pages/Beneficiaries/Shared/SubjectScreen/SubjectReadingColumn';
import SubjectScreenContainer from '@UI/Pages/Beneficiaries/Shared/SubjectScreen/SubjectScreenContainer';
import MembersContent from '@UI/Pages/Subjects/SubjectDetails/Pages/Members/MembersContent';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ConfirmDialog } from '@verclam/ui-kit';

const membersItems = [{ label: 'Membres' }] as const;

/**
 * Assembles the screen: breadcrumb, the data-owning `MembersContent`, the confirmation dialog host and
 * notifications. The bare `<ConfirmDialog />` is what receives the imperative `confirmDialog()` calls
 * of the rows. Redirects to the list of the type when the route's `subject` segment is not a valid id.
 */
const Members: React.FC = () => {
	const navigate = useNavigate();
	const { subjectType: typeKey = '' } = useParams<{ subjectType: string }>();
	const { subject } = useSubjectAddressParams();

	React.useEffect(() => {
		if (subject === null) {
			navigate(buildSubjectListPath(typeKey));
		}
	}, [subject, typeKey, navigate]);

	return (
		<SubjectScreenContainer>
			<ConditionalLoader data={subject}>
				{(presentSubject) => (
					<React.Fragment>
						<SubjectBreadcrumb subject={presentSubject} items={membersItems} />
						<SubjectReadingColumn>
							<MembersContent subject={presentSubject} />
						</SubjectReadingColumn>
					</React.Fragment>
				)}
			</ConditionalLoader>
			<ConfirmDialog />
			<SubjectsNotifications />
		</SubjectScreenContainer>
	);
};

export default Members;
